import React, { useRef } from "react";
import { Collapse, Form } from "antd";
import ConsultantForm from "./CommonComponents/ConsultantForm";
import PatientProfile from "./CommonComponents/PatientProfile";
import ClinicalImpression from "./CommonComponents/ClinicalImpression";
import HistoryIllness from "./CommonComponents/HistoryIllness";
import AdmissionFor from "./CommonComponents/AdmissionFor";
import DietInCenter from "./CommonComponents/DietInCenter/DietInCenter";
import NutritionalScreening from "./CommonComponents/NutritionalScreening";
import DietAdvised from "./DietAdvised";
import "./FormsIp.css";

const DietaryDischargeSummary = ({ patientData }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const commonStyle = {
    // background: "#fff",
    boxShadow:
      "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.1)",
  };
  return (
    <div>
      <Form form={form} ref={formRef} layout="vertical" className="forms-ip-shell">
        <Collapse
          expandIconPosition="end"
          className="custom-collapse forms-ip-collapse"
          defaultActiveKey={["1", "2", "3", "4", "5", "6", "7", "8", "9"]}
        >
          <Collapse.Panel header="Patient Profile" style={commonStyle} key="1">
            <PatientProfile data={patientData?.admission} />
          </Collapse.Panel>
          <Collapse.Panel header="Consultants" style={commonStyle} key="2">
            <ConsultantForm form={form} />
          </Collapse.Panel>
          <Collapse.Panel
            header="Clinical Impression/ Diagnosis"
            style={commonStyle}
            key="3"
          >
            <ClinicalImpression form={form} />
          </Collapse.Panel>
          <Collapse.Panel header="Admission For" style={commonStyle} key="5">
            <AdmissionFor form={form} />
          </Collapse.Panel>
          <Collapse.Panel header="Present Illness" style={commonStyle} key="4">
            <HistoryIllness form={form} />
          </Collapse.Panel>

          <Collapse.Panel
            header="Type of diet received while in the Center"
            style={commonStyle}
            key="6"
          >
            <DietInCenter form={form} />
          </Collapse.Panel>
          <Collapse.Panel
            header="Nutritional Screening on the day of Discharge"
            style={commonStyle}
            key="7"
          >
            <NutritionalScreening form={form} />
          </Collapse.Panel>
          <Collapse.Panel
            header="Type of diet advised at the time of discharge"
            style={commonStyle}
            key="8"
          >
            <DietAdvised form={form} />
          </Collapse.Panel>
        </Collapse>
      </Form>
    </div>
  );
};

export default DietaryDischargeSummary;
